// Basis-Liste der im Bucket „sige-sicherheitszeichen" vorhandenen ISO-7010-Codes.
// Dient als zuverlässige Grundmenge für das Auswahl-Grid (unabhängig von storage.list/RLS).
// Per Editor hochgeladene Zeichen kommen zur Laufzeit dynamisch hinzu.
// Bilder werden per piktoPfad() aus dem öffentlichen Bucket geladen.
export const ALLE_PIKTO_CODES: string[] = [
  'E002', 'E004', 'E008', 'E009', 'E010', 'E011', 'E012', 'E013', 'E014', 'E015',
  'E016', 'E017', 'E018', 'E019', 'E020', 'E021', 'E022', 'E023', 'E024', 'E025',
  'E026', 'E027', 'E028', 'E029', 'E030', 'E031', 'E032', 'E033', 'E034', 'E035',
  'E036', 'E037', 'E038', 'E039', 'E040', 'E041', 'E042', 'E043', 'E044', 'E045',
  'E046', 'E047', 'E048', 'E049', 'E050', 'E051', 'E052', 'E053', 'E054', 'E055',
  'E056', 'E057', 'E058', 'E059', 'E060', 'E061', 'E062', 'E063', 'E064', 'E065',
  'E067', 'E068', 'E069', 'E070', 'E071', 'E072', 'E073', 'E074', 'E075', 'E076',
  'F002', 'F003', 'F005', 'F006', 'F007', 'F008', 'F009', 'F010', 'F011', 'F012',
  'F013', 'F014', 'F015', 'F016', 'F017', 'F018', 'F019',
  'M003', 'M004', 'M008', 'M009', 'M014', 'M015', 'M018',
  'P001', 'P002', 'P003', 'P004', 'P005', 'P006', 'P007', 'P008', 'P009', 'P010',
  'P011', 'P012', 'P013', 'P014', 'P015', 'P016', 'P017', 'P018', 'P019', 'P020',
  'P021', 'P022', 'P023', 'P024', 'P025', 'P026', 'P027', 'P028', 'P029', 'P030',
  'P031', 'P032', 'P033', 'P034', 'P036', 'P037', 'P038', 'P039', 'P040', 'P041',
  'P042', 'P043', 'P044', 'P045', 'P046', 'P047', 'P048', 'P049', 'P050', 'P051',
  'P052', 'P053', 'P054', 'P055', 'P056', 'P057', 'P058', 'P059', 'P060', 'P061',
  'P062', 'P063', 'P064', 'P065', 'P066', 'P067', 'P068', 'P069', 'P070', 'P071',
  'P072', 'P073', 'P074', 'P075', 'P076', 'P077', 'P078', 'P079', 'P080',
  'W001', 'W002', 'W003', 'W004', 'W007', 'W008', 'W011', 'W012', 'W013', 'W014',
  'W015', 'W016', 'W017', 'W018', 'W020', 'W021', 'W022', 'W023', 'W024', 'W025',
  'W026', 'W027', 'W029', 'W073', 'W074', 'W075', 'W076', 'W077', 'W078', 'W080',
  'W082', 'W084', 'W085', 'W088',
];
